module.exports = __webpack_public_path__ + "img/125.5.ce32e8c0.png";